import React from 'react';
import { Box, Chip } from '@mui/material';
import { tint } from '../../theme';

export type StatusTone = 'success' | 'warning' | 'error' | 'info' | 'neutral';

interface StatusChipProps {
  label: string;
  tone?: StatusTone;
  title?: string;
}

/**
 * Status pill with a leading dot. The dot matters for accessibility: it gives
 * the state a second, non-colour cue alongside the label text.
 */
export const StatusChip: React.FC<StatusChipProps> = ({ label, tone = 'neutral', title }) => (
  <Chip
    size="small"
    title={title}
    label={label}
    icon={
      <Box
        component="span"
        aria-hidden="true"
        sx={{
          width: 6,
          height: 6,
          borderRadius: '50%',
          ml: '8px !important',
          mr: '-2px !important',
          bgcolor: tone === 'neutral' ? 'text.disabled' : `${tone}.main`,
        }}
      />
    }
    sx={{
      color: tone === 'neutral' ? 'text.secondary' : `${tone}.main`,
      bgcolor: (theme) =>
        tone === 'neutral' ? 'background.subtle' : tint(theme, `${tone}.main`, 0.12),
      border: (theme) =>
        '1px solid ' +
        (tone === 'neutral' ? theme.palette.divider : tint(theme, `${tone}.main`, 0.28)),
    }}
  />
);

export default StatusChip;
